import { createCtx } from "../hooks/createCtx";
type ModifyContext = {
  handleModeSwitch: () => void;
};

export const [useModifyContext, ModifyContextProvider] =
  createCtx<ModifyContext>();
